import { useEffect, useState } from "react";

import { validateResetToken } from "@/api/authentication";
import { useSearchParams, useParams, Navigate } from "react-router-dom";
import { MoonLoader } from "react-spinners";

import { useSession } from "@/hooks/server-state/use-session";

import ChangePassword from "@/components/widget/change-password";
import InvalidToken from "@/components/widget/invalid-token";

import { AuthLayout, ResumeLink } from "@/components/layout/auth-layout";

const RESUME_ADDRESS = import.meta.env.VITE_RESUME_ADDRESS;

const ChangePasswordPage = () => {
  const [searchParams] = useSearchParams();
  const { token } = useParams<{ token?: string }>();
  const { data: sessionData, isLoading } = useSession();
  const [isValidatingToken, setIsValidatingToken] = useState(false);
  const [isTokenValid, setIsTokenValid] = useState<boolean | null>(null);

  // خواندن مقدار از query string مثل ?requireOldPassword=false
  const requireOldPasswordParam = searchParams.get("requireOldPassword");

  // اگر توکن داریم (از URL parameter)، رمز قبلی نمی‌خواهیم
  // اگر توکن نداریم و requireOldPassword تنظیم نشده یا true است، رمز قبلی می‌خواهیم
  const requireOldPassword = token
    ? false
    : requireOldPasswordParam !== "false" && requireOldPasswordParam !== "0";

  // اعتبارسنجی توکن اگر وجود دارد
  useEffect(() => {
    const checkToken = async () => {
      if (!token) {
        setIsTokenValid(true); // اگر توکن نداریم، نیازی به اعتبارسنجی نیست
        return;
      }

      setIsValidatingToken(true);
      try {
        const result = await validateResetToken(token);
        // بررسی اینکه آیا نتیجه معتبر است
        setIsTokenValid(!!(result?.status && result?.data === true));
      } catch (error) {
        console.error("خطا در اعتبارسنجی توکن:", error);
        setIsTokenValid(false);
      } finally {
        setIsValidatingToken(false);
      }
    };

    checkToken();
  }, [token]);

  // اگر در حال بارگذاری است یا در حال اعتبارسنجی توکن، نمایش لودینگ
  if (isLoading || isValidatingToken) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-white">
        <MoonLoader color="#0068B8" size={50} />
      </div>
    );
  }

  // اگر توکن نامعتبر است، نمایش صفحه خطا
  if (token && isTokenValid === false) {
    const footerContent = <>{RESUME_ADDRESS && <ResumeLink />}</>;
    return (
      <AuthLayout footerContent={footerContent}>
        <InvalidToken />
      </AuthLayout>
    );
  }

  // اگر توکن ندارد و requireOldPassword=false نیست، به لاگین هدایت کن
  // (یعنی فقط با توکن یا با requireOldPassword=false می‌توان بدون لاگین دسترسی داشت)
  if (!token && requireOldPasswordParam !== "false" && !sessionData) {
    return <Navigate to="/dashboard/login" />;
  }

  const footerContent = <>{RESUME_ADDRESS && <ResumeLink />}</>;

  return (
    <AuthLayout footerContent={footerContent}>
      <ChangePassword requireOldPassword={requireOldPassword} token={token} />
    </AuthLayout>
  );
};

export default ChangePasswordPage;
